/**
 * @generated SignedSource<<5cab38f22dcd0462cdf474ffee90d62a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type readingHistoryActionMenuBookmarkButtonArticle$data = {
  readonly entityId: string;
  readonly urlAlias: string;
  readonly " $fragmentType": "readingHistoryActionMenuBookmarkButtonArticle";
};
export type readingHistoryActionMenuBookmarkButtonArticle$key = {
  readonly " $data"?: readingHistoryActionMenuBookmarkButtonArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"readingHistoryActionMenuBookmarkButtonArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "readingHistoryActionMenuBookmarkButtonArticle"
};

(node as any).hash = "a7c80ae823596510ff3e2edc0684d236";

export default node;
